import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-shopping-cart",
  templateUrl: "./med-icon-shopping-cart.component.html",
})
export class MedIconShoppingCartComponent extends SvgMixinComponent {}
